import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { customerTableColors } from '../helpers/customerTableColors';

export const StyledHeaderCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: customerTableColors.backgroundColorHead,
        fontSize: 12,
        fontWeight: 'bold',
        padding: 10,
    },
}));
